import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { userRolesPropShape } from 'AppSrc/core/auth/auth-proptypes';
import { userRolesSelector } from 'AppSrc/core/auth/auth-selectors';
import {
  COORDINATOR,
  REQUESTER,
} from 'AppSrc/core/components/forms/form-base-components/data-structure/constants';
import { OptionButton } from 'AppSrc/core/components/utility/option-button';
import {
  deleteMeEventuallyChangeUserRole,
  deleteMeEventuallyChangeRemedyId,
} from 'AppSrc/core/auth/auth-actions';
import {
  isStatusCoordinator,
  isStatusPeerReview,
  isStatusApprovals,
} from 'AppSrc/core/crq/crq-statuses';
import {
  hackBoiForApproversActionable,
} from 'AppSrc/core/actions/actions-edit-form';



const formDataFromServerShape = PropTypes.shape({
  formSectionsByDisplayOrder: PropTypes.array,
  dataByFormSectionId: PropTypes.object,
  status: PropTypes.string,
  coordinatorName: PropTypes.string,
  peerReviewerName: PropTypes.string,
  requesterName: PropTypes.string,
});




/* COMPONENT ONLY USED FOR DEVELOPMENT */
/* should be removed before delivery */
const DevUserRoleControlsDisplay = ({
  changeUserRole,
  userRoles,
}) => {
  // error sob face incase the user hasn't had roles set up yet
  const fixedRoleText = `Fixed: ${userRoles.fixed ? userRoles.fixed : 'error 😭'}`;
  const mobileRoleText = `Mobile: ${userRoles.mobile ? userRoles.mobile : 'error 😭'}`;

  // this should allow for testing for roles when roles haven't been given
  const newFixedRole = userRoles.fixed === COORDINATOR ? REQUESTER : COORDINATOR;
  const newMobileRole = userRoles.mobile === COORDINATOR ? REQUESTER : COORDINATOR;

  // NOTE: Fixed and mobile here come from a different set of data and so should not be turned
  // into constants, event though they are the same value as the MOBILE, FIXED constants
  const fixedOption = {
    roleToChange: 'fixed',
    newRole: newFixedRole,
  };

  const mobileOption = {
    roleToChange: 'mobile',
    newRole: newMobileRole,
  };

  return (
    <div className="delete-me-when-we-have-roles">
      <OptionButton
        type="button"
        onClick={changeUserRole}
        option={fixedOption}
      >
        {fixedRoleText}
      </OptionButton>
      <OptionButton
        type="button"
        onClick={changeUserRole}
        option={mobileOption}
      >
        {mobileRoleText}
      </OptionButton>
    </div>
  );
};

DevUserRoleControlsDisplay.propTypes = {
  changeUserRole: PropTypes.func,
  userRoles: userRolesPropShape,
};

const mapStateToProps = (state, ownProps) => ({
  userRoles: userRolesSelector(state),
});

// mapDispatchToProps tells the container component how to dispatch actions to the redux store
const mapDispatchToProps = (dispatch, ownProps) => ({
  changeUserRole: (options) => {
    dispatch(deleteMeEventuallyChangeUserRole(options.roleToChange, options.newRole));
  },
});

const DevUserRoleControlsHACK = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DevUserRoleControlsDisplay);



const DevRemedyIdControlsDisplay = ({
  changeRemedyIdHack,
  changeApprovers,
  network,
  formData,
}) => {

  if (!formData) {
    return null;
  }

  const {
    status,
    crqId,
    coordinatorId,
    peerReviewerId,
  } = formData;

  const statusCoordinator = isStatusCoordinator(status);
  const statusPeerReview = isStatusPeerReview(status);
  const statusApprovals = isStatusApprovals(status);


  return (
    <>
      {
        statusCoordinator && (
          <button
            type="button"
            className="HACK-for-user-id"
            onClick={() => changeRemedyIdHack(network, coordinatorId)}
          >
            Make me the: Coordinator
          </button>
        )
      }
      {
        statusPeerReview && (
          <button
            type="button"
            className="HACK-for-user-id"
            onClick={() => changeRemedyIdHack(network, peerReviewerId)}
          >
            Make me the: Peer Reviewer
          </button>
        )
      }
      {
        statusApprovals && (
          <button
            type="button"
            className="HACK-for-user-id"
            onClick={() => changeApprovers(crqId)}
          >
            Make me the: Approvers
          </button>
        )
      }
    </>
  );
};



// mapDispatchToProps tells the container component how to dispatch actions to the redux store
const mapDispatchToProps2 = (dispatch, ownProps) => ({
  changeRemedyIdHack: (network, remedyId) => {
    dispatch(deleteMeEventuallyChangeRemedyId(network, remedyId));
  },
  changeApprovers: (crqId) => {
    dispatch(hackBoiForApproversActionable(crqId));
  },
});

const DevRemedyIdControlsHACK = connect(
  null,
  mapDispatchToProps2,
)(DevRemedyIdControlsDisplay);

DevRemedyIdControlsDisplay.propTypes = {
  changeRemedyIdHack: PropTypes.func,
  changeApprovers: PropTypes.func,
  network: PropTypes.string,
  formData: formDataFromServerShape,
};

// if we are running a local dev build, the NODE_ENV environment variable is set to 'development'
const devBuild = process.env.NODE_ENV === 'development';
// if we are a build deployed from the develop branch (I.E vf-techops-dev),
// the REACT_APP_DRONE_BRANCH environment variable is set to 'develop'
const devDeploy = process.env.REACT_APP_DRONE_BRANCH === 'develop';
const devHacksEnabled = devBuild || devDeploy;
const ReturnNull = () => null;

const DevUserRoleControls = devHacksEnabled ? DevUserRoleControlsHACK : ReturnNull;
const DevRemedyIdControls = devHacksEnabled ? DevRemedyIdControlsHACK : ReturnNull;




export {
  DevUserRoleControls,
  DevRemedyIdControls,
};
